import { DsFormInstanceInterface } from '../interfaces/form-instance/ds-form-instance.interface';
import { DsFormInstanceSchemaInterface } from '../interfaces/form-instance/ds-form-instance-schema.interface';

export class DsFormInstance {
  /**
   *
   */
  public id: number;

  /**
   *
   */
  public name: string;

  /**
   *
   */
  public status: number;

  /**
   *
   */
  public version: number;

  /**
   *
   */
  public createdBy: number;

  /**
   *
   */
  public createdDate: number;

  /**
   *
   */
  public updatedBy: number;

  /**
   *
   */
  public updatedDate: number;

  /**
   *
   */
  public archive: number;

  /**
   *
   */
  public referenceId: string;

  /**
   *
   */
  public stepId: number;

  /**
   *
   */
  public formTemplateId: number;

  /**
   *
   */
  public formTemplateVersionId: number;

  /**
   *
   */
  public mapLocation: string;

  /**
   *
   */
  public mapAbsLocation: string;

  /**
   *
   */
  public mapId: number;

  /**
   *
   */
  public locked: number;

  /**
   *
   */
  public bimElementId: string;

  /**
   *
   */
  public schema: DsFormInstanceSchemaInterface;

  /**
   * Number to display inside instances list for the user to see, instead of the id.
   */
  public visualIdentifier: number;

  /**
   * Creates an instance of DsFormInstance.
   *
   * @param json the json data
   */
  constructor(json: DsFormInstanceInterface) {
    this.id = json.id;
    this.name = json.name;
    this.status = json.status;
    this.version = json.version;
    this.createdBy = json.created_by;
    this.createdDate = json.created_date;
    this.updatedBy = json.updated_by;
    this.updatedDate = json.updated_date;
    this.archive = json.archive;
    this.referenceId = json.reference_id;
    this.stepId = json.step_id;
    this.formTemplateId = json.form_template_id;
    this.formTemplateVersionId = json.form_template_version_id;
    this.mapLocation = json.map_location;
    this.mapAbsLocation = json.map_abs_location;
    this.mapId = json.map_id;
    this.locked = json.locked;
    this.bimElementId = json.bim_element_id;
    this.schema = json.schema;
    this.visualIdentifier = json.visual_identifier;
  }
}
